import service from "@/store/services/estados-tarea-service";

const state = {
  list: {},
  estado: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, estado) => {
    state.estado = estado;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params).then((estado) => {
      commit("SET_RESOURCE", estado);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((estado) => {
      commit("SET_RESOURCE", estado);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((estado) => {
      commit("SET_RESOURCE", estado);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  estado: (state) => state.estado,
  dropdown: (state) => {
    return state.list.map((estado) => ({
      id: estado.id,
      nombre: estado.nombre,
    }));
  },
};

const estadosTarea = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default estadosTarea;
